import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  API_BASE_URL,
  CRM_URL,
  CRM_URL_V1,
  SITE_KEY_V2,
} from "../../config/config";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, FormFeedback, Form } from "reactstrap";

import {
  xssSafeString,
  sanitizeInput,
  getApiAccessToken,
} from "../../utils/helper";
import ReCAPTCHA from "react-google-recaptcha";

export default function JCNLForm({
  pageName = "",
  planDetails = "",
}) {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getPageName, setPageName] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [getPlanDetails, setPlanDetails] = useState("");

  const [getAuthToken, setAuthToken] = useState(null);
  useEffect(() => {
    setPlanDetails(planDetails);
    setPageName(pageName);
    const fetchToken = async () => {
      try {
        var result = await getApiAccessToken();
        setAuthToken(result.token);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };
    fetchToken();
    const tokenInterval = setInterval(fetchToken, 60000);
    return () => clearInterval(tokenInterval);
  }, []);

  const handleSubmit = (newNav) => {
    setErrorMsg(false);

    if (!captchaToken) {
      setErrorMsg(true);
      return;
    }

    let data = {
      Details: newNav,
      token: captchaToken,
    };

    data.Details["service_type"] = getPageName;
    setLoading(true);
    axios
      .post(`${CRM_URL_V1}?cmd=jharkhand_inquiry`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken}`,
        },
      })
      .then((response) => {
        console.log("response", response);
        setLoading(false);
        setFormSubmitted(true);
        axios.post(`${API_BASE_URL}/api/jcnl/createJCNLInquiry`, data);
        setTimeout(() => {
          setFormSubmitted(false);
        }, 5000);
      })
      .catch((error) => {
        setErrorMsg(true);
      });
  };

  const [navigation, setNav] = useState(null);
  const validationInquiry = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: (navigation && navigation.name) || "",
      phone_no: (navigation && navigation.phone_no) || "",
      gram_panchayat: (navigation && navigation.gram_panchayat) || "",
      address: (navigation && navigation.address) || "",
      description: (navigation && navigation.description) || getPlanDetails,
    },
    validationSchema: Yup.object({
      name: xssSafeString("Please Enter Name").max(
        50,
        "Must be 50 characters or less",
      ),
      phone_no: Yup.string()
        .required("Please Enter Phone Number")
        .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
        .transform((value) => sanitizeInput(value)),
      gram_panchayat: xssSafeString("Please Enter Gram Panchayat").max(
        50,
        "Must be 50 characters or less",
      ),
      address: xssSafeString("Please Enter Address"),
      description: xssSafeString("Please Enter Description"),
    }),

    onSubmit: (values) => {
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get("utm_source") || "";
      const utmMedium = urlParams.get("utm_medium") || "";

      const newNav = {
        name: sanitizeInput(values.name),
        phone_number: sanitizeInput(values.phone_no),
        address: sanitizeInput(values.address),
        plan_detail: sanitizeInput(values.description),
        city: sanitizeInput(values.gram_panchayat),
        utm_source: sanitizeInput(utmSource),
        utm_medium: sanitizeInput(utmMedium),
      };

      handleSubmit(newNav);
      validationInquiry.resetForm();
    },
  });
  return (
    <>
      <div 
        className="form-wrapper banner-form"
        style={{
          boxSizing: "border-box",
          width: "100%",
        }}  
      >
        <Form
          id="internet_service"
          className={`${formSubmitted ? "submitted-success" : ""}${loading ? "loader-active" : ""}`}
          onSubmit={(e) => {
            e.preventDefault();
            validationInquiry.handleSubmit();
            return false;
          }}
        >
          {/* <h2>Get In Touch</h2> */}
          <div className="item">
            <label htmlFor="name">Name:</label>
            <Input
              type="text"
              id="name"
              name="name"
              style={{
                boxSizing: "border-box",   // ✅ CRITICAL
                padding: "10px 12px",      // ✅ lock padding
                width: "100%",
              }}
              onChange={validationInquiry.handleChange}
              onBlur={validationInquiry.handleBlur}
              value={validationInquiry.values.name || ""}
              invalid={
                validationInquiry.touched.name && validationInquiry.errors.name
                  ? true
                  : false
              }
              placeholder="Your Name"
            />
            {validationInquiry.touched.name && validationInquiry.errors.name ? (
              <FormFeedback type="invalid">
                {validationInquiry.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="item">
            <label htmlFor="phone_no">Phone Number:</label>
            <Input
              type="text"
              id="phone_no"
              name="phone_no"
                            style={{
                boxSizing: "border-box",   // ✅ CRITICAL
                padding: "10px 12px",      // ✅ lock padding
                width: "100%",
              }}
              onChange={validationInquiry.handleChange}
              onBlur={validationInquiry.handleBlur}
              value={validationInquiry.values.phone_no || ""}
              invalid={
                validationInquiry.touched.phone_no &&
                validationInquiry.errors.phone_no
                  ? true
                  : false
              }
              placeholder="Phone Number"
            />
            {validationInquiry.touched.phone_no &&
            validationInquiry.errors.phone_no ? (
              <FormFeedback type="invalid">
                {validationInquiry.errors.phone_no}
              </FormFeedback>
            ) : null}
          </div>
          <div className="item">
            <label htmlFor="gram_panchayat">Gram Panchayat:</label>
            <Input
              type="text"
              id="gram_panchayat"
              name="gram_panchayat"
              style={{
                boxSizing: "border-box",   // ✅ CRITICAL
                padding: "10px 12px",      // ✅ lock padding
                width: "100%",
              }}
              onChange={validationInquiry.handleChange}
              onBlur={validationInquiry.handleBlur}
              value={validationInquiry.values.gram_panchayat || ""}
              invalid={
                validationInquiry.touched.gram_panchayat &&
                validationInquiry.errors.gram_panchayat
                  ? true
                  : false
              }
              placeholder="Gram Panchayat"
            />
            {validationInquiry.touched.gram_panchayat &&
            validationInquiry.errors.gram_panchayat ? (
              <FormFeedback type="invalid">
                {validationInquiry.errors.gram_panchayat}
              </FormFeedback>
            ) : null}
          </div>
          <div className="item">
            <label htmlFor="address">Address:</label>
            <textarea
              name="address"
              style={{
                boxSizing: "border-box",   // ✅ CRITICAL
                padding: "10px 12px",      // ✅ lock padding
                width: "100%",
              }}
              value={validationInquiry.values.address}
              onChange={validationInquiry.handleChange}
              onBlur={validationInquiry.handleBlur}
              maxLength={255}
              className={`form-control ${
                validationInquiry.touched.address &&
                validationInquiry.errors.address
                  ? "is-invalid"
                  : ""
              }`}
              placeholder="Address with Landmark"
            ></textarea>
            {validationInquiry.touched.address &&
            validationInquiry.errors.address ? (
              <FormFeedback type="invalid">
                {validationInquiry.errors.address}
              </FormFeedback>
            ) : null}
          </div>
          <div className="item">
            <label htmlFor="description">Description:</label>
            <Input
              type="text"
              id="description"
              name="description"
              style={{
                boxSizing: "border-box",   // ✅ CRITICAL
                padding: "10px 12px",      // ✅ lock padding
                width: "100%",
              }}
              value={validationInquiry.values.description || getPlanDetails}
              onChange={validationInquiry.handleChange}
              onBlur={validationInquiry.handleBlur}
              invalid={
                validationInquiry.touched.description &&
                validationInquiry.errors.description
                  ? true
                  : false
              }
              className={`form-control ${validationInquiry.touched.description && validationInquiry.errors.description ? "is-invalid" : ""}`}
              placeholder="Message"
            />
            {validationInquiry.touched.description &&
            validationInquiry.errors.description ? (
              <FormFeedback type="invalid">
                {validationInquiry.errors.description}
              </FormFeedback>
            ) : null}
          </div>
          <div className="item">
            <ReCAPTCHA
              sitekey={SITE_KEY_V2} // v2 CHECKBOX key
              onChange={(token) => setCaptchaToken(token)}
              onExpired={() => setCaptchaToken(null)}
            />
          </div>

          <div className="item submit-item mb-0">
            <button
              type="submit"
              disabled={!captchaToken}
              className={`button btn-pacific-blue ${getPageName}`}
              style={{
                background: "#a0c9e8",
                color: "#5d84ac",
              }}
            >
              Submit
            </button>{" "}
          </div>
          {errorMsg && (
            <div className="form-error-msg form-text-center">
              <span className="errorMsg">
                Something Went Wrong!, Please try again later.
              </span>
            </div>
          )}
          {formSubmitted && (
            <div className="thanks-msg">
              <div className="main-container">
                <div className="check-container">
                  <div className="check-background">
                    <svg
                      viewBox="0 0 65 51"
                      fill="none"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 25L27.3077 44L58.5 7"
                        stroke="white"
                        stroke-width="13"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="check-shadow"></div>
                </div>
                <h4>"Thank you - We'll be in touch shortly to assist you."</h4>
              </div>
            </div>
          )}

          {loading && (
            <div className="loader-sec">
              <div className="main-container">
                <div className="check-container">
                  <span class="loader"></span>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    </>
  );
}
